var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import Money from '../../../../components/Money';
import Icon from '../../../../components/Icon';
import Translate from '../../../../components/Icon';

var SelectedPaymentMethod = function (_Component) {
  _inherits(SelectedPaymentMethod, _Component);

  function SelectedPaymentMethod() {
    _classCallCheck(this, SelectedPaymentMethod);

    return _possibleConstructorReturn(this, (SelectedPaymentMethod.__proto__ || Object.getPrototypeOf(SelectedPaymentMethod)).apply(this, arguments));
  }

  _createClass(SelectedPaymentMethod, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          selectedMethod = _props.selectedMethod,
          detail = _props.detail,
          currency = _props.currency,
          handleBack = _props.handleBack;

      return React.createElement(
        'div',
        { className: 'selected-payment-method-container' },
        React.createElement(
          'div',
          { className: 'icon-container', onClick: handleBack },
          React.createElement(Icon, { icon: 'angle-left' })
        ),
        React.createElement(
          'div',
          { className: 'payment-method-item-container' },
          detail && React.createElement('div', {
            className: 'provider-logo small',
            style: { backgroundImage: 'url(' + detail.image.file.url + ')' }
          }),
          React.createElement(
            'div',
            { className: 'method-info' },
            React.createElement(
              'div',
              { className: 'method-name' },
              detail.title
            ),
            selectedMethod.limit ? React.createElement(
              'div',
              { className: 'method-limit' },
              React.createElement(Translate, {
                id: 'noun.min_limit',
                values: {
                  limit: React.createElement(Money, {
                    value: selectedMethod.limit.min,
                    maximumFractionDigits: 0,
                    currency: currency
                  })
                }
              }),
              ' ',
              React.createElement(Translate, {
                id: 'noun.max_limit',
                values: {
                  limit: React.createElement(Money, {
                    value: selectedMethod.limit.max,
                    maximumFractionDigits: 0,
                    currency: currency
                  })
                }
              })
            ) : null
          )
        )
      );
    }
  }]);

  return SelectedPaymentMethod;
}(Component);

export default SelectedPaymentMethod;